<template>
  <table class='table is-striped is-fullwidth'>
    <thead>
      <tr>
        <th>Client</th>
        <th v-if='!hideRcpt'>Recipient Address</th>
        <th>Submitted At</th>
        <th>Status</th>
        <th>Status Info</th>
        <th>Status Updated At</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for='email in emails' :key='email.email_id'>
        <td
          :class='$style.clickable'
          @click='$emit("client-clicked", email.api_client_id)'
        >
          {{ email.api_client_name }}
        </td>
        <td v-if='!hideRcpt'>{{ email.rcpt_addr }}</td>
        <td>{{ $filters.formatDate(email.submitted_at) }}</td>
        <td>
          <span
            v-if='email.sendingSystem === "psm"'
            :class='$style.sendingSystemIndicator'
          >
            <span :class='$style.sendingSystemTooltip'>Sent through PSM</span>
            📧
          </span>
          <span
            v-else-if='email.sendingSystem === "dmi"'
            :class='$style.sendingSystemIndicator'
          >
            <span :class='$style.sendingSystemTooltip'>Sent through DMI</span>
            📥
          </span>
          <a :class='$style.clickable' :href='formatLogLink(email)' target='_blank'>
            {{ email.status }}
          </a>
        </td>
        <td>{{ email.status_info }}</td>
        <td>{{ $filters.formatDate(email.status_updated_at) }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import moment from 'moment-timezone';

const DATA_DOG_URL = 'https://app.datadoghq.com/logs';

export default {
  name: 'EmailList',

  props: {
    emails: {
      type: Array,
      default: () => []
    },
    hideRcpt: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    formatLogLink(email) {
      const {
        email_id: id,
        rcpt_id: recipientID,
        submitted_at: submitted,
        status_updated_at: updated
      } = email;

      const from = moment(submitted).subtract(1, 'minutes').valueOf();
      const to = moment(updated).add(1, 'minutes').valueOf();

      const query = `
        cols=@build_hash,@app,@service,@level,@elapsed_ms,@email_id,@rcpt_addr
        &event
        &live=false
        &query=app:psm
        +@email_id:${window.encodeURIComponent(id)}
        +@rcpt_id:${window.encodeURIComponent(recipientID)}
        &stream_sort=desc
        &from_ts=${from}
        &to_ts=${to}
      `.replace(/(?:\r\n|\r|\n|\s)/g, '');

      return `${DATA_DOG_URL}?${query}`;
    }
  }
}
</script>

<style lang='scss' module>
@import 'src/styles/variables.scss';

.clickable {
  color: $link-light;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: $link-hover;
  }
}

.sendingSystemIndicator {
  cursor: default;
  position: relative;

  &:hover {
    .sendingSystemTooltip {
      display: inline-block;
    }
  }
}

.sendingSystemTooltip {
  background: #000;
  display: none;
  left: -4em;
  padding: 0.25em 0.45em;
  position: absolute;
  top: -2.1em;
  text-align: center;
  width: 9em;
}

</style>
